export default {"src":"/_next/static/media/zipmi_logo.57acdbf8.svg","height":36,"width":128,"blurWidth":0,"blurHeight":0};